const selectMessageCategories = state => state.data.messageCategories

const MessageCategoryDataStoreSelectors = {
  messageCategories: selectMessageCategories
}

export default MessageCategoryDataStoreSelectors
